import './styles/FilterTitle.scss';

export default function FilterTitle({title}){
    return (
        <div className='filterTitle'>
            <h5>{title}</h5>
        </div>
    )
}